import React from "react";
import {useTranslation} from "react-i18next";
import {AlpineKeyLogo} from "../assets/logo/alpineKeyLogo";

function Home() {
    const {t} = useTranslation();

    return (
        <div className="home-container">
            <div className="home-content">
                <h2>{t("menu.home")}</h2>
                <p>{t("home.description")}</p>
            </div>

            <div className="home-logo">
                <AlpineKeyLogo size={100}/>
            </div>
        </div>
    );
}

export default Home;